// extracted by mini-css-extract-plugin
export default {"root":"AnimatedRoute_root__sxtxL","full":"AnimatedRoute_full__5hIWZ"};